import React from 'react';
import { useState, useEffect, useRef } from 'react';
import './ProjectModal.css';
import { projectData } from '../Data/ProjectData.js';


function ProjectModal({ isOpen, projectId, onClose }) {

    if (!isOpen || !projectId) return null;
    const project = projectData[projectId];

  return (
    <div className="modal active" onClick={(e) => e.target.classList.contains('modal') && onClose()}>
        <div className="modal-content bg-white rounded-2xl p-8 max-w-5xl mx-4 mx-4 max-h-[90vh] overflow-y-auto">
            <div className="flex justify-between items-center mb-6">
                <h3 className="text-3xl font-bold text-gray-800">{project.title}</h3>
                <button onClick={onClose} className="w-fit p-6 hover:bg-gray-100 rounded-full transition-colors">
                    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path>
                    </svg>
                </button>
            </div>
            <div className="space-y-6">
                <div className="grid lg:grid-cols-3 gap-8">
                    <div className="lg:col-span-2 space-y-6">
                        <div>
                            <h4 className="text-xl font-semibold text-gray-800 mb-3">Project Overview</h4>
                            <p className="text-gray-600">{project.overview}</p>
                        </div>

                        <div>
                            <h4 className="text-xl font-semibold text-gray-800 mb-3">Challenge</h4>
                            <p className="text-gray-600">{project.challenge}</p>
                        </div>

                        <div>
                            <h4 className="text-xl font-semibold text-gray-800 mb-3">Approach</h4>
                            <div className="bg-blue-50 p-4 rounded-lg">
                                <pre className="text-blue-800 whitespace-pre-line text-sm">{project.approach}</pre>
                            </div>
                        </div>

                        <div>
                            <h4 className="text-xl font-semibold text-gray-800 mb-3">Results & Impact</h4>
                            <div className="bg-emerald-50 p-4 rounded-lg">
                                <pre className="text-emerald-800 whitespace-pre-line text-sm">{project.results}</pre>
                            </div>
                        </div>
                    </div>

                    <div className="space-y-6">
                        <div className="bg-gray-50 p-6 rounded-lg">
                            <h4 className="text-lg font-semibold text-gray-800 mb-4">Project Metrics</h4>
                            <div className="space-y-3">
                                <div className="flex justify-between">
                                    <span className="text-gray-600">Budget:</span>
                                    <span className="font-semibold">{project.metrics.budget}</span>
                                </div>
                                <div className="flex justify-between">
                                    <span className="text-gray-600">Timeline:</span>
                                    <span className="font-semibold">{project.metrics.timeline}</span>
                                </div>
                                <div className="flex justify-between">
                                    <span className="text-gray-600">Team Size:</span>
                                    <span className="font-semibold">{project.metrics.team}</span>
                                </div>
                                {/* <div className="flex justify-between">
                                    <span className="text-gray-600">Stakeholders:</span>
                                    <span className="font-semibold">{project.metrics.stakeholders}</span>
                                </div> */}
                            </div>
                        </div>

                        <div className="bg-gray-50 p-6 rounded-lg">
                            <h4 className="text-lg font-semibold text-gray-800 mb-3">Methodology</h4>
                            <p className="text-gray-600 text-sm">{project.methodology}</p>
                        </div>

                        <div className="bg-gray-50 p-6 rounded-lg">
                            <h4 className="text-lg font-semibold text-gray-800 mb-3">Tools & Technologies</h4>
                            <p className="text-gray-600 text-sm">{project.tools}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  );
}

export default ProjectModal;